module.exports = "/assets/b129d08d09a86d18d262bb57106097fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/Z8.png
// module id = 3172
// module chunks = 0